"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useFormSubmit;

var _react = require("react");

var _Editor = require("./Editor");

function useFormSubmit() {
  var _useEditor = (0, _Editor.useEditor)(),
      submit = _useEditor.submit,
      registerSubmit = _useEditor.registerSubmit;

  (0, _react.useEffect)(registerSubmit);
  return submit;
}